<template>
<div>
  <HeaderGestion/>
  <SubHeaderGestion
    nombreGestion="Libros"
  />
  <section>
    <FormLibros/>
  </section>
</div>
</template>

<script>
import HeaderGestion from '../components/HeaderGestion.vue'
import SubHeaderGestion from '../components/SubHeaderGestion.vue'
import FormLibros from '../components/FormLibros.vue'
export default {
  components: { HeaderGestion, SubHeaderGestion, FormLibros },
  name: 'GesLibros',
  data () {
    return {
      gestion: 'Gestión colecciones'
    }
  },
  methods: {
    goToGestion () {
      this.$router.push('/menuColecciones')
    }
  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
</style>
